import React, { useEffect, useState } from 'react';

const Origin = () => {
  const [posts, setPosts] = useState([]);
  const [subredditInfo, setSubredditInfo] = useState(null);

  useEffect(() => {
    // Fetch subreddit info
    fetch('https://www.reddit.com/r/starterpacks/about.json')
      .then((res) => res.json())
      .then((data) => setSubredditInfo(data.data));

    // Fetch image posts
    fetch('https://www.reddit.com/r/starterpacks.json')
      .then((res) => res.json())
      .then((data) => {
        const items = data.data.children
          .map((child) => child.data)
          .filter(
            (post) =>
              post.preview &&
              post.preview.images &&
              post.preview.images[0]?.source?.url
          );
        setPosts(items.slice(0, 10));
      });
  }, []);

  return (
    <div className="dark:text-white px-4 py-8 flex flex-col items-center">
      <h2 className="font-vt323 text-[44px] text-center mb-6">The Origins</h2>

      {/* Subreddit Stats Header */}
      {subredditInfo && (
        <div className="bg-[#1a1a1a] rounded-lg shadow p-6 max-w-4xl mx-auto mb-10 flex items-center justify-between flex-wrap gap-4" style={{'width': '100%'}}>
          <div className="flex items-center gap-4">
            <img
              src="https://www.redditstatic.com/desktop2x/img/favicon/apple-icon-180x180.png"
              alt="Reddit logo"
              className="w-12 h-12 rounded-full"
            />
            <div>
              <h3 className="font-vt323 text-2xl">r/{subredditInfo.display_name}</h3>
              <p className="text-gray-400 text-sm">{subredditInfo.public_description}</p>
            </div>
          </div>
          <div className="text-left font-vt323 text-lg">
            👥 {subredditInfo.subscribers.toLocaleString()} members<br />
            🟢 {subredditInfo.accounts_active.toLocaleString()} online
          </div>
        </div>
      )}

      {/* Post Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {posts.map((post) => {
          const imageUrl = post.preview.images[0].source.url.replace(/&amp;/g, '&');

          return (
            <a
              key={post.id}
              href={`https://reddit.com${post.permalink}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1a1a1a] rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <img
                src={imageUrl}
                alt={post.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="font-vt323 text-xl mb-2">{post.title}</h3>
                <p className="text-sm text-gray-400">
                  👍 {post.ups} · 💬 {post.num_comments}
                </p>
              </div>
            </a>
          );
        })}
      </div>
      <a
            href="https://www.reddit.com/r/starterpacks"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center px-6 py-2 bg-[#3070B7] text-white rounded-md hover:bg-red-700 transition duration-300"
        >
            <img
            src="https://www.redditstatic.com/desktop2x/img/favicon/apple-icon-180x180.png"
            alt="Reddit Logo"
            className="w-5 h-5 mr-2"
            />
            View on Reddit
        </a>
    </div>
  );
};

export default Origin;
